/**
 * Enum representing different presets for notification settings.
 */
export enum NotificationsPresetEnum {
	/**
	 * Represents the default preset with a balanced set of options.
	 * @description This preset includes most common notification settings that are
	 * used by the majority of users new to the system.
	 */
	DEFAULT = 'default',

	/**
	 * Represents a preset of the most important options leaving out the rest of the noisy
	 * notifications.
	 * @description This preset includes only the most critical notifications
	 * that users need to be aware of, omitting less important ones.
	 */
	FOCUSED = 'focused',

	/**
	 * Represents a preset that includes a balanced set of options
	 * but only sends notifications for records that the user owns.
	 * @description This preset is similar to the DEFAULT preset but filters out notifications
	 * for records that the user did not create.
	 */
	OWNED_ONLY = 'owned-only',

	/**
	 * Represents a custom preset where users can select their own options.
	 * @description This preset allows users to configure their notification settings
	 * according to their personal preferences, enabling or disabling specific notifications.
	 */
	CUSTOM = 'custom',
}
